import PricingComponentToggle from './PricingComponentToggle';
export default PricingComponentToggle;
